"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Fleet() {
  const artifacts = [{
    id: 1,
    title: "Executive Sedan",
    spec: "2 PASSENGERS/2 LUGGAGE/ BUSINESS SEDAN COMFORT / DISCREET",
    image: {
      src: "http://bemaxlimo.com/wp-content/uploads/2026/09/3CB4D4DF-D484-4F95-846C-F63F553D74E9-1.jpg?v=vf2k8hcvb1o",
      srcset: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/3CB4D4DF-D484-4F95-846C-F63F553D74E9-1.jpg?v=qrzxsbanb8-wvc-srcset",
      sizes: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/3CB4D4DF-D484-4F95-846C-F63F553D74E9-1.jpg?v=z2moclp2lnf-wvc-sizes",
      alt: "Black executive sedan parked at a private terminal"
    }
  }, {
    id: 2,
    title: "Luxury SUV",
    spec: "BUSINESS SUV\n6 PASSENGERS/ 5 LUGGAGE",
    image: {
      src: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_1575.jpeg?v=nggttjwix",
      srcset: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3747-1.jpg?v=guo8exlr0y-wvc-srcset",
      sizes: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3747-1.jpg?v=yrd89hyhd-wvc-sizes",
      alt: "Luxury SUV interior and exterior detail"
    }
  }, {
    id: 3,
    title: "Executive Sprinter Van",
    spec: "LIMO / EXECUTIVE / JET\xA0\nSPRINTER",
    image: {
      src: "http://bemaxlimo.com/wp-content/uploads/2026/09/IMG_4902-2.jpg?v=87xba7369yw",
      srcset: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3111-1.webp?v=c8lxhafuus5-wvc-srcset",
      sizes: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3111-1.webp?v=djohc234ard-wvc-sizes",
      alt: "Executive Sprinter van for group travel"
    }
  }, {
    id: 5,
    title: "Premium SUV",
    spec: "FIRST CLASS SUV\xA0\n6 PASSENGERS/5 LUGGAGE /\xA0",
    image: {
      src: "http://bemaxlimo.com/wp-content/uploads/2026/07/IMG_1181.avif?v=9omeefh07hq",
      srcset: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_0625-1.webp?v=viky6nbwel-wvc-srcset",
      sizes: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_0625-1.webp?v=iijc3v7xvr-wvc-sizes",
      alt: "Premium SUV for business travel"
    }
  }, {
    id: 6,
    title: "Sprinter Van",
    spec: "CORPORATE / SPORT EVENT / NIGHT OUT",
    image: {
      src: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/VLL-Fleet-Photos-21.jpg.jpeg?v=dw0nwk3505h",
      srcset: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/VLL-Fleet-Photos-21.jpg.jpeg?v=o6plagcxjf-wvc-srcset",
      sizes: "https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/VLL-Fleet-Photos-21.jpg.jpeg?v=d4bzxv195r-wvc-sizes",
      alt: "Private shuttle for corporate transport"
    }
  }];
  return <section data-section-id="2781" id="fleet-preview" className="bg-black text-white py-20 md:py-28 lg:py-36 px-6 md:px-10 lg:px-16 light">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 mb-16 md:mb-24 items-start">
          <div className="md:col-span-1">
            <span className="font-mono text-xs uppercase tracking-widest text-gray-500">
              § 01
            </span>
          </div>
          <div className="md:col-span-7">
            <p className="font-mono text-xs uppercase tracking-widest text-gray-500 mb-4">
              Our Fleet
            </p>
            <h2 className="font-default font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-white">
              Refined transportation
            </h2>
            <p className="font-mono text-xs uppercase tracking-widest text-gray-400 mt-6 max-w-md">
              premium transportation, assured Luxury travel, whevever you are going, RIDE BLCS
            </p>
          </div>
          <div className="md:col-span-4 md:flex md:justify-end md:items-end md:h-full">
            <Link to="/FleetPage" className="group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-white border-b border-gray-700 pb-1 hover:border-white transition-colors duration-500">
              <span>View full fleet</span>
              <ArrowUpRight className="size-3.5 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.5} />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {artifacts.map((item, i) => <Link key={item.id} data-index={i} to="https://book.mylimobiz.com/v4/bemax" newTab className="group relative flex flex-col overflow-hidden rounded-lg bg-[#050505] border border-white/10 hover:border-white/30 transition-all duration-500">
              <div className="relative w-full overflow-hidden aspect-[16/10] bg-black">
                <img src={item.image.src} data-wvc-srcset={item.image.srcset} data-wvc-sizes={item.image.sizes} alt={item.image.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />

                <div className="absolute top-4 left-4 z-10">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-white/90 bg-black/60 backdrop-blur-md px-2.5 py-1 rounded-md border border-white/10">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>

                <div className="absolute top-4 right-4 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-black bg-white px-3 py-1.5 rounded-md inline-flex items-center gap-1.5 font-medium shadow-sm">
                    Reserve
                    <ArrowUpRight className="size-3" strokeWidth={1.5} />
                  </span>
                </div>
              </div>

              <div className="p-6 flex flex-col justify-between flex-1 gap-4">
                <div>
                  <h3 className="font-default text-xl md:text-2xl text-white font-medium leading-tight mb-2 group-hover:text-white transition-colors">
                    {item.title}
                  </h3>
                  <p className="font-mono text-xs uppercase tracking-widest text-gray-400">
                    {item.spec}
                  </p>
                </div>

                <div className="pt-4 border-t border-white/5 flex items-center justify-between">
                  <span className="font-mono text-[11px] uppercase tracking-widest text-gray-400 group-hover:text-white transition-colors inline-flex items-center gap-1.5">
                    Reserve Vehicle
                    <ArrowUpRight className="size-3.5 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
                  </span>
                </div>
              </div>
            </Link>)}
        </div>

        <div className="mt-20 md:mt-28 pt-8 border-t border-[#111111] flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="font-mono text-[11px] uppercase tracking-widest text-gray-500">
            BEMAX LIMO — Chauffeured service
          </p>
          <p className="font-mono text-[11px] uppercase tracking-widest text-gray-500">
            {artifacts.length} premium vehicles shown
          </p>
        </div>
      </div>
    </section>;
}